import { render, staticRenderFns } from "./TView.vue?vue&type=template&id=88f189a6&scoped=true&"
import script from "./TView.vue?vue&type=script&lang=js&"
export * from "./TView.vue?vue&type=script&lang=js&"
import style0 from "./TView.vue?vue&type=style&index=0&id=88f189a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f189a6",
  null
  
)

export default component.exports